import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AppLocale, DEFAULT_LOCALE } from './locale.constants';
import { LocaleService } from './locale.service';

const setLocaleForRoute = (locale: AppLocale): boolean => {
  inject(LocaleService).setRouteLocale(locale);
  return true;
};

export const englishLocaleGuard: CanActivateFn = () => setLocaleForRoute('en');

export const portugueseLocaleGuard: CanActivateFn = () => setLocaleForRoute('pt-BR');

export const defaultLocaleGuard: CanActivateFn = () => {
  return setLocaleForRoute(DEFAULT_LOCALE);
};
